<template>
    <div class="is-grow-1 mt-4">
        <div v-show="!$root.gmapsFailure" class="mapa-wrapper pt-2" :class="{ disabled: disabled }">
            <gmap-map
                ref="mapRef"
                class="gmaps"
                :center="center"
                :zoom="zoomLevel"
                :options="mapOptions"
                @click="addToPath"
            >
                <gmap-polygon
                    ref="polygonRef"
                    :paths="path"
                    :options="pathOptions"
                    :editable="isDrawingPolygon"
                    :draggable="isDrawingPolygon"
                    @paths_changed="updatePath"
                    @rightclick="handleClickForDelete"
                />

                <gmap-polyline :path="routeLine" :options="lineOptions" :editable="false" />

                <!-- TOOLTIP -->
                <gmap-info-window
                    ref="tooltipWindow"
                    :position="tooltipWindow.position"
                    :opened="tooltipWindow.open"
                    :options="tooltipWindow.options"
                    @closeclick="tooltipWindow.open = false"
                >
                    <div class="info-window">
                        <p class="info-window-nome">{{ tooltipWindow.item.rsocial }}</p>
                        <div class="info-detail" v-if="tooltipWindow.item.inRoute">
                            <span class="has-text-weight-bold">{{ $t('ordem') }}:</span>
                            <span class="has-text-right">{{ tooltipWindow.item.ordem }}</span>
                        </div>
                        <div class="info-detail" v-if="tooltipWindow.item.inRoute">
                            <span class="has-text-weight-bold">{{ $t('periodo') }}:</span>
                            <span class="has-text-right">{{
                                $t(getPeriodo(tooltipWindow.item.periodoDia))
                            }}</span>
                        </div>
                        <div class="info-detail" v-if="tooltipWindow.item.inRoute">
                            <span class="has-text-weight-bold">{{ $t('observacao') }}:</span>
                            <span class="has-text-right" v-if="tooltipWindow.item.observacao">{{
                                tooltipWindow.item.observacao
                            }}</span>
                            <span class="has-text-right has-text-grey" v-else
                                >({{ $t('sem-observacao') }})</span
                            >
                        </div>
                        <div
                            v-if="!assRotaClienteIntegracao"
                            class="is-flex is-flex-centered mt-4 mb-1"
                        >
                            <button
                                class="save-btn small-btn"
                                v-if="!tooltipWindow.item.inRoute"
                                @click="addOneToRoute(tooltipWindow.item.idcliente)"
                            >
                                {{ $t('adicionar') }}
                            </button>
                            <button
                                class="delete-btn small-btn"
                                v-else
                                @click="removeCliente(tooltipWindow.item.idcliente)"
                            >
                                {{ $t('remover') }}
                            </button>
                        </div>
                    </div>
                </gmap-info-window>
            </gmap-map>
        </div>

        <!-- Botão de retrair -->
        <div
            ref="retractBtn"
            class="retract-button"
            :class="{ 'hide-control-right-btn': !showPanel }"
            v-show="!loadingMap && !$root.gmapsFailure"
        >
            <div class="btn-wrapper" @click="showPanel = !showPanel">
                <b-icon :icon="showPanel ? 'chevron-right' : 'chevron-left'" />
            </div>
        </div>

        <!-- Lista dentro do Mapa -->
        <div
            ref="listaStatus"
            class="control-right"
            :class="{ 'hide-control-right': !showPanel }"
            v-show="!loadingMap && !$root.gmapsFailure"
        >
            <div class="control-container padded is-flex">
                <div class="columns">
                    <div class="column is-full is-flex is-flex-hbetween">
                        <button
                            class="delete-btn small-btn"
                            @click="clearPolygon"
                            :disabled="!path.length"
                        >
                            {{ $t('limpar-area') }}
                        </button>
                        <button
                            class="delete-btn small-btn"
                            @click="centerOnRoute"
                            :disabled="!inRoute.length"
                        >
                            {{ $t('centralizar-rota') }}
                        </button>
                        <button
                            v-if="!assRotaClienteIntegracao"
                            class="save-btn small-btn"
                            @click="addToRoute"
                            :disabled="!selected.length"
                        >
                            {{ $t('add-area-rota') }}
                        </button>
                    </div>
                </div>
                <div class="is-grow-1 ctrl-table-wrapper">
                    <table class="table is-100 ctrl-table">
                        <thead>
                            <tr>
                                <th style="width: 33px"></th>
                                <th class="has-text-centered order-col">#</th>
                                <th>{{ $t('cliente') }}</th>
                                <th class="has-text-centered" style="width: 30px">
                                    <!-- Ações -->
                                </th>
                            </tr>
                        </thead>
                        <v-draggable
                            :value="rota"
                            @input="updateRoutes"
                            tag="tbody"
                            handle=".t-handle"
                        >
                            <tr v-for="(r, ordem) in rota" :key="r.cliente.id">
                                <td v-if="!assRotaClienteIntegracao" class="t-handle">
                                    <b-icon icon="drag-horizontal" size="is-small" type="is-dark" />
                                </td>
                                <td v-else></td>
                                <td class="has-text-centered">
                                    <div
                                        v-if="!(r.cliente.latitude && r.cliente.longitude)"
                                        class="is-flex is-flex-centered disabled"
                                        style="position: relative"
                                        v-tippy
                                        :title="$t('msg-cliente-sem-localizacao')"
                                    >
                                        <div class="pin-icon">
                                            <svg viewBox="0 0 20 26" class="pin-tbl">
                                                <path class="path" :d="svgpath_closed"></path>
                                            </svg>
                                        </div>
                                        <div class="pin-nro">{{ ordem + 1 }}</div>
                                    </div>

                                    <div
                                        v-else
                                        class="is-flex is-flex-centered is-clickable"
                                        style="position: relative"
                                        @click="showOnMap(r, ordem + 1)"
                                    >
                                        <div class="pin-icon">
                                            <svg viewBox="0 0 20 26" class="pin-tbl">
                                                <path class="path" :d="svgpath_closed"></path>
                                            </svg>
                                        </div>
                                        <div class="pin-nro">{{ ordem + 1 }}</div>
                                    </div>
                                </td>
                                <td>{{ r.cliente.rsocial }}</td>
                                <td>
                                    <div
                                        v-if="!assRotaClienteIntegracao"
                                        class="buttons has-addons is-flex-nowrap"
                                    >
                                        <b-button
                                            type="is-danger"
                                            icon-right="close"
                                            size="is-small"
                                            @click.stop="removeCliente(r.cliente.id)"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </v-draggable>
                    </table>
                </div>
            </div>
        </div>

        <div ref="btnControl" v-show="!loadingMap && !$root.gmapsFailure">
            <button
                v-if="!isDrawingPolygon"
                ref="editBtn"
                class="save-btn ctrl-mapa mt-2 ml-2"
                @click="isDrawingPolygon = true"
                v-tippy
                :title="$t('msg-tooltip-habilitar-area')"
            >
                <b-icon icon="pencil" />
            </button>

            <button
                v-else
                ref="editBtn"
                class="delete-btn ctrl-mapa mt-2 ml-2"
                @click="disableDrawing"
                v-tippy
                :title="$t('msg-tooltip-desabilitar-area')"
            >
                <b-icon icon="pencil-off" />
            </button>
        </div>
    </div>
</template>

<script>
import MarkerClusterer from 'marker-clusterer-plus';
import { gmapApi } from 'vue2-google-maps';

export default {
    props: {
        rota: {
            /* {idrotavisita, cliente, ordem, periododia, observacao} */
            type: Array,
            default: () => [],
        },
        clientes: {
            /* {idcliente, nome, rsocial, cnpjcpf, ierg, endereco, latitude, longitude} */
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            assRotaClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSROTAVISITACLIENTE'
            ),
            isMapInitialized: false,
            center: { lat: -12.867, lng: -55.625 },
            zoomLevel: 4,
            isDrawingPolygon: false,
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                clickableIcons: false,
                fullscreenControlOptions: {
                    position: 7, //google.maps.ControlPosition.RIGHT_TOP
                },
            },
            pathOptions: {
                strokeColor: this.$store.state.partnerSystemHasLayout.primary_color,
                fillColor: this.$store.state.partnerSystemHasLayout.primary_color,
            },
            inRouteColor: '#419545' /* green alert click */,
            lineOptions: {
                strokeColor: '#4CAF50',
                strokeOpacity: 0.5,
                icons: [
                    {
                        icon: { path: 1 /*google.maps.SymbolPath.FORWARD_OPEN_ARROW*/ },
                        offset: '40%',
                        repeat: '50px',
                    },
                ],
            },
            /* SVG do pin com o buraco em cima */
            svgpath:
                'M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z',
            /* SVG do pin fechado para por o número da ordem dentro */
            svgpath_closed:
                'M10.081.004C4.426.093 0 4.646 0 10.253 0 17.809 8.723 24.981 10 26 11.277 24.981 20 17.809 20 10.253 20 4.646 15.574.093 10.081.004Z',
            showPanel: true,
            loadingMap: true,
            path: [],
            markers: [],
            cluster: null,
            clusterOptions: {
                maxZoom: 12,
                zoomOnClick: true,
                minimumClusterSize: 10,
                styles: [
                    {
                        textColor: 'white',
                        url: '', // Traz a imagem no mounted pra garantir o tema carregado
                        fontFamily: 'Montserrat,sans-serif',
                        fontWeight: 'normal',
                        height: 45,
                        width: 45,
                    },
                ],
            },
            tooltipWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -35 },
                },
            },
            updateMarkers: null,
        };
    },
    created() {
        this.updateMarkers = this.debounce(function () {
            this.$refs.mapRef.$mapPromise.then((map) => {
                if (google && google.maps.geometry) {
                    let clientes_com_localizacao_fora = this.clientes.filter(
                        (e) => e.latitude && e.longitude && !this.inRoute.includes(e.idcliente)
                    );

                    this.$refs.mapRef.$mapPromise.then((map) => {
                        if (!this.isMapInitialized) {
                            this.initMap(map);
                        }

                        let newMarkers = [];

                        clientes_com_localizacao_fora.forEach((c) => {
                            let polygon = this.$refs.polygonRef.$polygonObject;

                            let position = new google.maps.LatLng(c.latitude, c.longitude);

                            let isInPolygon = google.maps.geometry.poly.containsLocation(
                                position,
                                polygon
                            );

                            let marker = new google.maps.Marker({
                                position: position,
                                inPolygon: isInPolygon,
                                inRoute: false,
                                cliente: c,
                                icon: {
                                    path: this.svgpath,
                                    fillColor: isInPolygon
                                        ? this.$store.state.partnerSystemHasLayout.secondary_color
                                        : this.$store.state.partnerSystemHasLayout.primary_color,
                                    scale: 1,
                                    fillOpacity: 1,
                                    strokeWeight: 0,
                                    anchor: { x: 10, y: 25 },
                                    labelOrigin: { x: 10, y: 10 },
                                },
                            });

                            let self = this; // this não está disponível dentro da function

                            marker.addListener('click', function () {
                                self.openInfo(marker);
                            });

                            newMarkers.push(marker);
                        });

                        this.rota
                            .filter((e) => e.cliente && e.cliente.latitude && e.cliente.longitude)
                            .forEach((r, ordem) => {
                                let position = {
                                    lat: r.cliente.latitude,
                                    lng: r.cliente.longitude,
                                };

                                let marker = new google.maps.Marker({
                                    position: position,
                                    inPolygon: false,
                                    inRoute: false,
                                    cliente: r.cliente,
                                    icon: {
                                        path: this.svgpath_closed,
                                        fillColor: this.inRouteColor,
                                        scale: 1,
                                        fillOpacity: 1,
                                        strokeWeight: 0,
                                        anchor: { x: 10, y: 25 },
                                        labelOrigin: { x: 10, y: 10 },
                                    },
                                    label: {
                                        text: (ordem + 1).toString(),
                                        color: '#fff',
                                        fontWeight: '600',
                                        fontSize: '11px',
                                        fontFamily: 'Montserrat,sans-serif',
                                    },
                                });

                                let self = this; // this não está disponível dentro da function

                                marker.addListener('click', function () {
                                    self.openInfo(marker);
                                });

                                newMarkers.push(marker);
                            });

                        this.$set(this, 'markers', newMarkers);
                        this.cluster.clearMarkers();
                        this.cluster.addMarkers(this.markers);
                    });
                }
            });
        }, 200);
    },
    computed: {
        /* Necessário para evitar o erro google is undefined */
        google: gmapApi,

        selected() {
            return this.markers.filter((e) => e.inPolygon && !e.inRoute);
        },
        inRoute() {
            return this.rota.map((e) => e.cliente.idcliente);
        },
        routeLine() {
            return this.rota
                .filter((e) => e.cliente && e.cliente.latitude != 0 && e.cliente.longitude != 0)
                .map((e) => {
                    return { lat: e.cliente.latitude, lng: e.cliente.longitude };
                });
        },
    },
    mounted() {
        this.$refs.mapRef.$mapPromise.then((map) => {
            if (!this.isMapInitialized) {
                this.initMap(map);
            }
        });
    },
    methods: {
        initMap(map) {
            /* O map vem da promise ali no mounted ou no watch de clientes lá embaixo */
            this.isMapInitialized = true;

            // Configs de clusterização
            this.clusterOptions.styles[0].url = this.getMapClusterSvg();
            this.cluster = new MarkerClusterer(
                this.$refs.mapRef.$mapObject,
                [],
                this.clusterOptions
            );

            // Monta as divs dentro do mapa
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.retractBtn);
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.listaStatus);
            map.controls[google.maps.ControlPosition.LEFT_TOP].push(this.$refs.btnControl);

            this.loadingMap = false;
        },
        addToPath(evt) {
            if (evt && evt.latLng && this.isDrawingPolygon) {
                /* O método toJSON retorna um objeto do tipo {lat: Number, lng: Number} */
                this.path.push(evt.latLng.toJSON());
                this.updateMarkers();
            }
        },
        updatePath(evt) {
            if (evt && evt.getArray() && this.isDrawingPolygon) {
                // Primeiro há um array de polígonos, dele retira-se somente o primeiro
                let polygons = evt.getArray() || [];

                if (polygons[0]) {
                    // Do polígono, tira-se os pontos
                    let newPath = polygons[0].getArray() || [];

                    /*  Cada item é um objeto de latLng do gmaps que tem 
                        um método toJSON para retornar um objeto com lat e lng */
                    this.path = newPath.map((e) => e.toJSON());
                }

                this.updateMarkers();
            }
        },

        handleClickForDelete($event) {
            if ($event.vertex >= 0) {
                this.$refs.polygonRef.$polygonObject
                    .getPaths()
                    .getAt($event.path)
                    .removeAt($event.vertex);
            }
        },
        clearPolygon() {
            this.path = [];
            this.updateMarkers();
        },
        removeCliente(id) {
            this.$emit('remove-cliente', id);
        },
        addOneToRoute(idcliente) {
            this.$emit('add-clientes', [idcliente]);
        },
        addToRoute() {
            this.$emit(
                'add-clientes',
                this.selected.map((e) => e.cliente.idcliente)
            );
        },
        updateRoutes(routes) {
            this.$emit('update', routes);
        },
        showOnMap(r, ordem) {
            let cliente = this.clientes.find((e) => e.idcliente == r.cliente.idcliente);

            this.tooltipWindow.position = {
                lat: r.cliente.latitude,
                lng: r.cliente.longitude,
            };

            if (!cliente) {
                cliente = r.cliente;
            }

            this.tooltipWindow.item = cliente;
            this.tooltipWindow.item.ordem = ordem;
            this.tooltipWindow.item.inRoute = true;
            this.tooltipWindow.item.periodoDia = r.periodoDia;
            this.tooltipWindow.item.observacao = r.observacao;

            this.tooltipWindow.open = true;
        },
        openInfo(m) {
            let inRoute = this.inRoute.includes(m.cliente.id);

            this.tooltipWindow.position = m.position;
            this.tooltipWindow.item = m.cliente;
            this.tooltipWindow.item.inRoute = inRoute;

            if (inRoute) {
                let index = this.rota.findIndex((e) => e.cliente.id == m.cliente.id);

                this.tooltipWindow.item.ordem = index + 1;
                this.tooltipWindow.item.periodoDia = this.rota[index].periodoDia;
                this.tooltipWindow.item.observacao = this.rota[index].observacao;
            }

            this.tooltipWindow.open = true;
        },
        updateInfoWindow() {
            if (this.tooltipWindow.open && this.tooltipWindow.item.idcliente) {
                let id_cliente = this.tooltipWindow.item.idcliente;
                let index = this.rota.findIndex((e) => e.cliente.id == id_cliente);

                if (index > -1) {
                    let rota = this.rota[index];

                    this.$set(this.tooltipWindow.item, 'inRoute', true);
                    this.$set(this.tooltipWindow.item, 'ordem', index + 1);
                    this.$set(this.tooltipWindow.item, 'periodoDia', rota.periodoDia);
                    this.$set(this.tooltipWindow.item, 'observacao', rota.observacao);
                } else {
                    this.$set(this.tooltipWindow.item, 'inRoute', false);
                    this.$set(this.tooltipWindow.item, 'ordem', undefined);
                    this.$set(this.tooltipWindow.item, 'periodoDia', undefined);
                    this.$set(this.tooltipWindow.item, 'observacao', undefined);
                }

                this.$forceUpdate();
            }
        },
        getPeriodo(periodo) {
            switch (periodo) {
                case 0:
                    return 'manha';
                case 1:
                    return 'tarde';
                case 2:
                    return 'noite';
                default:
                    return 'nao-informado';
            }
        },
        disableDrawing() {
            this.isDrawingPolygon = false;
            this.clearPolygon();
        },
        centerOnRoute() {
            this.$refs.mapRef.$mapPromise.then((map) => {
                let bounds = new google.maps.LatLngBounds();

                this.routeLine.forEach((r) => {
                    bounds.extend(r);
                });

                map.fitBounds(bounds);
            });
        },
    },
    watch: {
        rota(novos) {
            this.clearPolygon();
            this.updateInfoWindow();
        },
        /*  Este método será executado quando os clientes mudarem.
            Isto é após o carregamento dos clientes que vem do RotaVisita.vue
            Quando mudar os clientes, mostrá-los no mapa. */
        clientes() {
            this.updateMarkers();
        },
    },
};
</script>

<style lang="scss" scoped>
.mapa-wrapper {
    height: 100%;
    min-height: 500px;

    &.disabled {
        opacity: 0.5;
    }

    .gmaps {
        height: 100%;
    }
}

button.ctrl-mapa {
    width: 50px;
    height: 50px;
    padding: 0;
}

.pin-tbl {
    width: 25px;
    height: 25px;
    fill: $green-alert-click;
}

.pin-nro {
    position: absolute;
    top: 3px;
    color: $sovis-white;
    font-weight: 600;
}
</style>
